import axios from 'axios';

export default {
  getClientToken,
  updatePaypalInfo,
  getPaymentProfiles,
  savePaymentProfile,
  deletePaymentProfile,
  setDefaultPaymentProfile,
};

export function getClientToken() {
  return axios.get('/api/paymentProfile/getClientToken');
}

export function updatePaypalInfo(params) {
  return axios.post('/api/customer/updatePaypalInfo', params);
}

export function getPaymentProfiles() {
  return axios.get('/api/paymentProfile/getActivePaymentProfiles');
}

export function savePaymentProfile(params) {
  return axios.post('/api/customer/updateBillingInfo', params);
}

export function deletePaymentProfile(params) {
  return axios.post('/api/customer/deletePaymentProfile',  params);
}

export function setDefaultPaymentProfile(params) {
  return axios.post('/api/customer/setDefaultPaymentMethod', params);
}
